exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.mat-table tbody tr:hover {\n  background-color: white !important; }\n  table.mat-table tbody tr:hover input {\n    caret-color: black; }\n\n.mat-table .mat-button {\n  font-size: 0.8em; }\n\n.mat-table .variety {\n  min-width: 112px; }\n\n.mat-table .plot .mat-sort-header-button {\n  text-align: left; }\n\n.tool-bar {\n  margin-top: 10px;\n  margin-bottom: 10px; }\n  .tool-bar button {\n    margin-left: 10px;\n    text-transform: uppercase; }\n    .tool-bar button.mat-primary .mat-button-wrapper {\n      color: white; }\n", ""]);

// exports
